import EmptyPayment from './EmptyPayment';

export default EmptyPayment;
